export const MODAL_NAME = {
  ENABLE_2FA: 'ENABLE_2FA',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  RUN_TEST: 'RUN_TEST',
  INTEGRATION: 'INTEGRATION',
  HISTORY_CODE: 'HISTORY_CODE',
};
